import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SuperAdminService } from 'src/app/super-admin.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-view-tracker-invoice',
  templateUrl: './view-tracker-invoice.component.html',
  styleUrls: ['./view-tracker-invoice.component.css']
})
export class ViewTrackerInvoiceComponent implements OnInit {

  showFixedRateTable: boolean = false;
  showDefaultTable: boolean = false;
  invtot: any = 0;
  tooltaxPaidtot: any = 0;
  extrahour: any = 0;
  kmtot: any = 0;
  billno: string;
  invoiceDate: string = '';
  invoiceMonth: string = '';
  users: any[] = [];
  paramId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService
  ) {
    this.route.params.subscribe(param => {
      this.paramId = param.id;
      this.getTrackerInvoice(this.paramId);
    });
  }

  ngOnInit(): void { }

  // 🔹 TRACKER INVOICE FETCH (same structure as LR)
  getTrackerInvoice(id: string) {
    this.superAdminService.getParticularInvoice(id).subscribe(
      (res: any) => {
        if (res.status) {
          const rawdata = res.data;
          this.billno = rawdata[0]?.billNo || '';
          this.invoiceDate = this.formatDate(rawdata[0]?.createdAt);
          this.invoiceMonth = this.formatMonth(rawdata[0]?.createdAt);

          const invoiceType = rawdata[0]?.invoiceType || rawdata[0]?.invoice[0]?.invoiceTypeName?.[0] || 'Type1';
          const type = invoiceType?.trim();
          const isFixedRate = type === 'Fixed Rate Invoice' || type === 'Monthly Fixed Invoice';

          if (isFixedRate) {
            this.showFixedRateTable = true;
            this.showDefaultTable = false;
          } else {
            this.showFixedRateTable = false;
            this.showDefaultTable = true;
          }

          this.users = rawdata[0]?.invoice || [];

          // RESET TOTALS
          this.invtot = 0;
          this.kmtot = 0;
          this.extrahour = 0;
          this.tooltaxPaidtot = 0;

          // CALCULATE TOTALS (SAME AS LR)
          this.users.forEach((user: any) => {
            this.invtot += (user.vehicleRate || []).reduce(
              (a: number, b: any) => a + Number(b || 0),
              0
            );
            this.kmtot += (user.up_down_km || []).reduce(
              (a: number, b: any) => a + Number(b || 0),
              0
            );
            this.extrahour += (user.extrahour || []).reduce(
              (a: number, b: any) => a + Number(b || 0),
              0
            );
            this.tooltaxPaidtot += (user.tooltaxPaid || []).reduce(
              (a: number, b: any) => a + Number(b || 0),
              0
            );
          });

        } else {
          this.toastr.error(res.message);
        }
      },
      err => console.error(err)
    );
  }

  // 🔹 SEND EMAIL (PDF) – SAME AS LR
  // sendInvoice(divName: string) {
  //   const data = document.getElementById(divName);
  //   if (!data) return;

  //   html2canvas(data).then(canvas => {
  //     const imgWidth = 208;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //     const contentDataURL = canvas.toDataURL('image/png', 0.3);

  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     pdf.addImage(
  //       contentDataURL,
  //       'PNG',
  //       1,
  //       1,
  //       imgWidth,
  //       imgHeight,
  //       undefined,
  //       'FAST'
  //     );

  //     let binary = pdf.output();
  //     binary = binary ? btoa(binary) : '';

  //     this.superAdminService.sendTrackerInvoice(this.paramId, binary).subscribe(
  //       (res: any) => {
  //         res.status
  //           ? this.toastr.success(res.message)
  //           : this.toastr.error(res.message);
  //       }
  //     );
  //   });
  // }

  backTo() {
    window.history.back();
  }

  getDisplayValue(value: any): string {
    if (value === null || value === undefined || value === '') return '-';
    return value;
  }

  getTopDisplayValue(value: any): string {
    if (value === null || value === undefined || value === '') return 'N/A';
    return value;
  }

  getActualWorkingDays(startDate: any, endDate: any): any {
    if (!startDate || !endDate) return '-';
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return '-';
    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays === 0 ? 1 : diffDays;
  }

  getNum(value: any): number {
    if (value === null || value === undefined || value === '') return 0;
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  getExtraKmVal(user: any, i: number): number {
    const totalKm = this.getNum(user.up_down_km?.[i]);
    const fixedKm = this.getNum(user.fixedKM?.[i]);
    return Math.max(0, totalKm - fixedKm);
  }

  getAmountForKm(user: any, i: number): number {
    return this.getExtraKmVal(user, i) * this.getNum(user.extraKMCost?.[i]);
  }

  getAmountForExtraHrs(user: any, i: number): number {
    return this.getNum(user.extrahour?.[i]) * this.getNum(user.variableCostHr?.[i]);
  }

  getRowTotalAmount(user: any, i: number): number {
    const A = this.getNum(user.fixedPaymentMonth?.[i]);
    const B = this.getAmountForKm(user, i);
    const C = this.getAmountForExtraHrs(user, i);
    const D = this.getNum(user.tooltaxPaid?.[i]);
    const E = this.getNum(user.otherPayment?.[i]);
    return A + B + C + D + E;
  }

  getGrandTotal(users: any[]): number {
    let total = 0;
    if (!users || !users.length) return 0;
    for (let user of users) {
      if (user.vehicle_id) {
        for (let i = 0; i < user.vehicle_id.length; i++) {
          total += this.getRowTotalAmount(user, i);
        }
      }
    }
    return total;
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return 'N/A';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return 'N/A';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  }

  formatMonth(dateStr: string): string {
    if (!dateStr) return 'N/A';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return 'N/A';
    return d.toLocaleString('en-US', { month: 'long' });
  }
}
